import { render } from "./proforma-settings.vue?vue&type=template&id=bc8e8522"
import script from "./proforma-settings.vue?vue&type=script&lang=js"
export * from "./proforma-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__